module.exports = __webpack_public_path__ + "static/img/ningbopu.9a6cece.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ningbopu.png
// module id = 8i1V
// module chunks = 1